module.exports = __webpack_public_path__ + "img/logo-text.87cbbdd8.png";